<template>
    <div style="min-height: 500px;">
        <div class="record_box">
            <div class="list_css">
                <div style="display: flex; width: 380px; justify-content: space-between;align-items: center;">
                    <Avatar  size="50" :src="item.avatar"/>
                    <div>
                        <div style="display: flex;width: 100%; justify-content: space-between;">
                            <span style="font-size: 23px;">{{item.name}}</span>
                            <span style="font-size: 23px; color: #D0D2D4;" v-if="item.is_read == 1">已读</span>
                            <span style="font-size: 23px; color: red" v-else>未读</span>
                        </div>
                        <div style="font-size: 16px; color: #A89A93; display: flex; width: 300px; justify-content: space-between;">
                            <span style="">{{item.created_at}}</span>
                            <span>{{item.department_name}}</span>
                        </div>
                    </div>
                </div>
                <div class="list_width"
                     style="display: flex; justify-content: space-between; width: 750px; margin-top: 20px;">
                    <div>
                        <span>{{item.prefix_now}}上门客户：</span>
                        <span style="color: #277dd3;cursor: pointer;" @click="visitDataClick(item.uid,1,item.date_time)">{{item.view_nums}}位</span>
                    </div>
                    <div>
                        <span>{{item.prefix_now}}签约客户：</span>
                        <span style="color: #277dd3;cursor: pointer;">{{item.sign_nums}}位</span>
                    </div>
                    <div>
                        <span>{{item.prefix_now}}进件：</span>
                        <span style="color: #277dd3;cursor: pointer;">{{item.client_nums}}件</span>
                    </div>
                    <div>
                        <span>回款金额：</span>
                        <span>{{item.repay_money}}</span>
                    </div>
                </div>
                <div class="list_width"
                     style="display: flex; justify-content: space-between; width: 750px; margin-top: 5px;">
                    <div>
                        <span>{{item.prefix_now}}跟进客户数量：</span>
                        <span style="color: #277dd3;cursor: pointer;" @click="clientClick(item.uid,3,4,item.date_time)">{{item.follow_nums}}位</span>
                    </div>
                    <div>
                        <span>跟进次数：</span>
                        <span style="color: #277dd3;cursor: pointer;" @click="clientClick(item.uid,3,4,item.date_time)">{{item.follow_times}}次</span>
                    </div>
                    <div>
                        <span>通话次数：</span>
                        <span >{{item.call_nums}}次</span>
                    </div>
                    <div>
                        <span>通话时长：</span>
                        <span>{{item.call_time}}分钟</span>
                    </div>
                </div>
                <div class="list_width"
                     style="display: flex; justify-content: space-between; width: 550px; margin-top: 5px;">
					 <div>
					     <span>业绩目标：</span>
					     <span>{{item.achievement}}</span>
					 </div>
                    <div>
                        <span>本月业绩：</span>
                        <span>{{item.month_repay_money}}</span>
                    </div>
					<div>
					   <span><Progress :percent="item.achievement_rate" :stroke-width="20" status="active" text-inside /></span>
					</div>
                </div>
				<div class="list_width"
				     style="display: flex; justify-content: space-between; width: 355px; margin-top: 5px;">
				
				</div>
				<div class="list_width" style="margin-top: 10px;font-weight: bold;">今日上门客户：</div>
				<div v-for="(data,index) in item.ext_info.view_list">
					<Row style="margin-top: 20px;">
						<Col span="6">
							<span style="margin-left: 100px;">{{data.name}}</span>
						</Col>
						<Col span="8">
							<span style="padding-right: 10px;">上门结论</span>
							<Select v-model="data.status" style="width:200px">
								<Option v-for="item in stateList" :value="item.value" :key="item.value">
									{{ item.label }}
								</Option>
							</Select>
						</Col>
						<Col span="8">
							<Input v-model="data.view_remark" placeholder="请输入客户备注"/>
						</Col>
					</Row>
				</div>	
                <div class="list_width" style="margin-top: 10px;font-weight: bold;">今日工作总结：</div>
                <div style="margin-top: 5px;margin-left: 108px;">{{item.summarize}}</div>
                <div class="list_width" style="margin-top: 10px;font-weight: bold;">需要协助或遇到的问题：</div>
                <div style="margin-top: 5px;margin-left: 108px;">{{item.issue}}</div>
                <div class="list_width"
                     style="width: 80%; margin-top: 10px;  border: 1px solid #DADCE0; border-radius: 5px; padding: 10px;">
                    <div style="width: 100%;" v-for="(remark, remarkIndex) in item.ext_info.comment"><span style="font-weight: bold;">{{remark}}</span></div>
                    <div style="display: flex;  justify-content: flex-end;width: 100%;">
                        <Input v-model="remarkValue" style="width: 300px;margin-right: 20px;"/>
                        <Button type="primary" @click="saveComment" :data-id="item.id">点评/回复</Button>
                    </div>
                </div>
            </div>
			<Modal v-model="visitDataModal" width="1200" title="来访客户">
				<TodayCustomer :follow_uid_props = "follow_uid" :timePeriod_props="timePeriod" :timePeriodDate_props="timePeriodDate"></TodayCustomer> 
			</Modal>
			<Modal v-model="clickJumpClientShow" width="1300" height="500">
				<ClickJumpClient ref="ClickJumpClient" :timePeriod="timePeriod" :get_uid="get_uid"  :client_type="client_type" :timeType="timeType" :timePeriodDate="timePeriodDate"></ClickJumpClient>
			</Modal>
        </div>
    </div>
</template>

<script>
    import {mapActions, mapGetters} from "vuex";
	import {getReportList,saveReportComment,getDateLog} from '@/api/task'
	import TodayCustomer from '../TodayCustomer.vue'
	import ClickJumpClient from '../../client/ClickJumpClient.vue';
	export default {
        name: "RecordList",
		computed:{
			...mapGetters(['userInfo', 'token']),
		},
		components:{
			TodayCustomer,
			ClickJumpClient
		},
		props:['id'],
		created(){
			this.getDateLog();
		},
		watch: {
			id() {
				this.getDateLog();
			},
		},
        data() {
            return {
				clickJumpClientShow:false,
				visitDataModal:false,
				follow_uid:'',
				get_uid:'',
				timeType:'3',
				client_type:'4',
                remarkValue: '',
                name: '',
                dateTime: '',
                type: '',
				timePeriod: '7',
				timePeriodDate: [],
                type_list: [{
                    value: 'day',
                    label: '日报'
                },{
					value: 'week',
					label: '周报'
				},{
					value: 'month',
					label: '月报'
				},],
				list: [],
				count: 0,
				page: 1,
				item:[],
				stateList: [{
						value: 1,
						label: '未处理',
						is_true: 0
					},
					{
						value: 2,
						label: '待跟进',
						is_true: 0
					},
					{
						value: 3,
						label: '邀约中',
						is_true: 0
					},
					{
						value: 6,
						label: '上门未签约',
						is_true: 0
					},
					{
						value: 7,
						label: '已签约',
						is_true: 0
					},
					{
						value: 8,
						label: '进件中',
						is_true: 0
					},
					{
						value: 9,
						label: '银行拒绝',
						is_true: 0
					},
					{
						value: 13,
						label: '已回款',
						is_true: 0
					},
					{
						value: 14,
						label: '资质不符',
						is_true: 0
					},
					{
						value: 15,
						label: '捣乱申请',
						is_true: 0
					},
					{
						value: 16,
						label: '外地申请',
						is_true: 0
					},
					{
						value: 17,
						label: '重复申请',
						is_true: 0
					},
					{
						value: 18,
						label: '短信申请',
						is_true: 0
					}
				],
            }
        },
		methods: {
            ...mapActions([
                'getUserInfo',
            ]),
			async getDateLog(){
				let that = this;
                let data = {token: that.token, id: that.id}
                let res = await getDateLog(that, data);
                if (res.code == 1) {
                    that.item = res.data.item;
					console.log(that.item)
                }
			},
			search() {
        		this.page = 1;
        		this.getList();
			},
			changePage(e) {
				this.page = e;
				this.getList();
			},
			visitDataClick(type_id,type,timePeriodDate) {
				let that = this;
				if(type == 1){
					that.follow_uid = type_id;
				}else{
					that.department_id = type_id;
				}
				that.timePeriodDate[0] =timePeriodDate;
				that.timePeriodDate[1] =timePeriodDate;
				that.visitDataModal = true;
			},
			clientClick(get_uid,timeType,client_type,timePeriodDate) {
				let that = this;
				//time:时间  today：今天 yesterday:昨天 week:本周 thismonth:本月
				//timeType:时间类型 1：客户申请时间 2：分发时间 3、备注更新时间
				that.get_uid = get_uid?get_uid:0;
				that.timeType = 0;
				that.client_type = client_type;
				that.timePeriodDate[0] =timePeriodDate;
				that.timePeriodDate[1] =timePeriodDate;
				console.log(that.timePeriodDate);
				that.clickJumpClientShow = true;
			},
			saveComment(e) {
				let that = this;
				let id = e.currentTarget.dataset.id;
				this.throttle(async function () {
					let data = {token: that.token, id:id, remark: that.remarkValue}
					let res = await saveReportComment(that, data);
					if (res.code == 1) {
						that.$Message.success('评论成功')
						that.remarkValue = '';
                        that.getList();
					}
				}, 500)
			}

		}
    }
</script>

<style scoped lang="less">
    .sousuo {
        display: flex;
        width: 400px;
        justify-content: space-between;
    }

    .list_css {
        padding: 20px;
        width: 90%;
        border: 2px solid #EEEEEE;
        border-radius: 5px;
        margin: 20px 0;
    }

    .list_width {
        margin-left: 80px;

        div {
            width: 160px;
        }
    }

    .record_box {
        height: 690px;
        overflow: scroll;
    }

    .record_box::-webkit-scrollbar {
        width: 5px;
        height: 4px;
        background-color: #f5f5f5;
    }

    .record_box::-webkit-scrollbar-thumb {
        border-radius: 3px;
        background-color: #cae1f5;
    }

    .record_box::-webkit-scrollbar-track {
        background-color: #eeeeee;
    }
</style>
